__turbopack_context__.v({
  "option-color-tiles": "qgU-1G_option-color-tiles",
  "optionColorTiles": "qgU-1G_optionColorTiles",
  "selected": "qgU-1G_selected",
  "visual-swatch": "qgU-1G_visual-swatch",
});
